import { useState } from "react";
import { apiClient } from "../../lib/api";
import { openPreview } from "./PreviewWindow";

// Descarga de un reporte generado por el Orquestador: se pide con la sesión del usuario (cabecera Authorization) y se guarda como archivo.
async function readError(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;
  try {
    const raw = data && typeof data.text === "function" ? await data.text() : data;
    const detail = (typeof raw === "string" ? JSON.parse(raw) : raw)?.detail;
    if (detail) return detail;
  } catch (e) {
    /* sin detalle legible */
  }
  if (status === 410) return "El archivo expiró (se guarda 24 horas). Pídelo de nuevo.";
  if (status === 404) return "Ese reporte ya no está en el servidor. Pídelo de nuevo.";
  return "No se pudo descargar el archivo. Inténtalo de nuevo.";
}

export function ActionBar({ actions, onSendMessage }) {
  const [downloadError, setDownloadError] = useState("");

  const download = async (action) => {
    setDownloadError("");
    try {
      const res = await apiClient.get(`/exports/${action.download_id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = action.filename || "reporte";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setDownloadError(await readError(err));
    }
  };

  return (
    <div data-testid="message-action-bar" className="mt-4">
      <div className="flex flex-wrap gap-2">
        {actions.map((action, i) => (
          <button
            key={i}
            data-testid={`message-action-button-${i}`}
            onClick={() => (action.preview_token ? openPreview(action.preview_token, action.preview_title) : action.download_id ? download(action) : onSendMessage(action.send_message))}
            className={`text-sm font-medium px-3.5 py-2 rounded-[10px] text-[#0f0f10] transition-[filter,background-color] ${
              i === 0 ? "bg-gradient-to-br from-[#80fff9] to-[#1588fc] hover:brightness-110" : "bg-[#ddddE6] hover:bg-white"
            }`}
          >
            {action.download_id ? "⬇ " : ""}
            {action.label}
          </button>
        ))}
      </div>
      {downloadError && (
        <p data-testid="download-error" className="text-sm text-red-500 mt-3">
          {downloadError}
        </p>
      )}
    </div>
  );
}
